//angular imports
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';


@Component({
  selector: "list-filter",
  templateUrl: "./list-filter.component.html",
  styleUrl: "./list-filter.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListFilterComponent {
  public inputValue = input<string>("");
  public clippedSearch = input<boolean>(false);

  @Output()
  public updateFilter = new EventEmitter<any>();

  public searchEntity(event: any) {
    this.updateFilter.emit(event);
  }
}
